import { Link } from 'react-router';

import acai from 'assets/images/homeRevamp/ingredients/0-acai.png';
import acaciaCollagen from 'assets/images/ingredients/acacia-collagen.png';
import aniseed from 'assets/images/ingredients/aniseed-myrtle-extract.png';
import dogRoseFruit from 'assets/images/ingredients/dog-rose-fruit.png';
import jujubeBarkExtract from 'assets/images/ingredients/jujube-bark-extract.png';
import kombucha from 'assets/images/ingredients/kombucha.png';
import macaRoot from 'assets/images/ingredients/maca-root.png';
import peppermintExtract from 'assets/images/ingredients/peppermint-extract.png';
import riceProtein from 'assets/images/ingredients/rice-protein.png';
import rosemary from 'assets/images/ingredients/rosemary.png';
import densityBeforeAfterCarouselImg from 'assets/images/productPages/scalpSerum/before-after-carousel-density.jpg';
import oilinessBeforeAfterCarouselImg from 'assets/images/productPages/scalpSerum/before-after-carousel-oiliness.jpg';
import rednessBeforeAfterCarouselImg from 'assets/images/productPages/scalpSerum/before-after-carousel-redness.jpg';
import thicknessBeforeAfterCarouselImg from 'assets/images/productPages/scalpSerum/before-after-carousel-thickness.jpg';
import comfortableSvgIcon from 'assets/images/productPages/scalpSerum/comfortable.svg';
import upsellModuleImage from 'assets/images/productPages/scalpSerum/density-hair-set-upsell-module.png';
import healthSvgIcon from 'assets/images/productPages/scalpSerum/health.svg';
import hydratedSvgIcon from 'assets/images/productPages/scalpSerum/hydrated.svg';
import itchySvgIcon from 'assets/images/productPages/scalpSerum/itchy.svg';
import nourishedSvgIcon from 'assets/images/productPages/scalpSerum/nourished.svg';
import scalpSerum0 from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-0.jpg';
import scalpSerum0Desktop from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-0-d.jpg';
import scalpSerum1 from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-1.jpg';
import scalpSerum1Desktop from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-1-d.jpg';
import scalpSerum2 from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-2.jpg';
import scalpSerum3 from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-3.jpg';
import scalpSerum3Desktop from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-3-d.jpg';
import scalpSerum4 from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-4.jpg';
import scalpSerum4Desktop from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-4-d.jpg';
import scalpSerum5 from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-5.jpg';
import scalpSerum5Desktop from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-5-d.jpg';
import scalpSerum6 from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-6.jpg';
import scalpSerum6Desktop from 'assets/images/productPages/scalpSerum/scalp-serum-carousel-6-d.jpg';
import scalpSerumHowItWorksPicture from 'assets/images/productPages/scalpSerum/scalp-serum-how-to-use.jpg';

const ticker = [
  'cruelty free',
  'peta approved',
  'alcohol free',
  'sulfate free',
  'paraben free',
  'mineral oil free',
  'phthalate free',
  'gmo free',
  'available fragrance free',
  'silicone-free options',
  'vegan options',
];

const faq = {
  title: 'FAQs',
  questions: [
    {
      question: 'Why should I include Prose Custom Scalp Serum in my hair wellness regimen?',
      answer: `Simply put, healthy hair starts at the scalp — and Prose Custom Scalp Serum provides continuous support to nourish it to its healthiest expression. Just as plants draw nutrients from the earth through strong roots, our personalized scalp serum works to hydrate dry scalps and address any imbalances that can lead to itchiness, flakiness, oiliness, and irritation. With a healthy, balanced foundation, fuller, denser, and more voluminous hair can flourish.`,
    },
    {
      question: 'How is a Custom Scalp Serum different from a Custom Scalp Mask?',
      answer: (
        <>
          Designed for daily application, Prose Custom Scalp Serum offers continuous support for the
          scalp, helping to maintain hydration, soothe irritation, and promote fuller, thicker hair
          over time. As a leave-on product, it remains on the scalp throughout the day or night,
          allowing its clinically tested ingredients to penetrate deeply and work consistently.
          <br />
          <br />
          In complement — and contrast — we recommend Prose Custom Scalp Mask as a refreshing weekly
          reset to focus on exfoliating and detoxifying the scalp by removing impurities and
          reducing scalp buildup. This allows for other treatments, like our daily scalp serum, to
          be absorbed more effectively.
        </>
      ),
    },
    {
      question: 'How soon will I see results with Prose Custom Serum?',
      answer: (
        <>
          This will vary for each individual, but in a rigorous, in-house use test, participants saw
          remarkable results over 30 days, including immediate soothing, less itchiness, and hair
          that felt cleaner longer. Within a few weeks of use, your scalp should start feeling more
          balanced and hydrated and after 30 days you can expect a healthier scalp and stronger
          hair. Stay committed and you’ll continue to see the results of hair that looks more full,
          dense, and voluminous. <i>Results may vary.</i>
          <br />
          <br />
          If for any reason you’re not completely satisfied with the results of your Custom Scalp
          Serum, you can{' '}
          <Link rel="noopener noreferrer" target="_blank" to="/faq/contact-us">
            contact The Pros
          </Link>{' '}
          — your support team of custom haircare experts.
        </>
      ),
    },
    {
      question: 'Is Prose Custom Scalp Serum safe to use on color and keratin treated hair?',
      answer:
        'Yes and yes! If you let us know that you have keratin or color-treated hair during the consultation, we’ll select your ingredients accordingly and make sure your Custom Scalp Serum formula is safe for your hair.',
    },
    {
      question: `Can I use the scalp serum in conjunction with a prescription-grade hair product? (Finasteride, Minoxidil, etc.)`,
      answer: (
        <>
          Our Custom Scalp Serum does not contain drug ingredients or require a medical
          prescription, so no interference with other products is expected. However, as always, we
          recommend consulting with your doctor if you are taking any prescription medications.
          <br />
          <br />
          Just so you know, our Custom Scalp Serum formula is composed of 99% ingredients of natural
          origin. To help stabilize and protect your formula, we also use a small percentage of
          gentle, preservative alternatives chosen for their proven record of safety, efficacy, and
          sustainability. We never use phthalates, parabens, alcohols, mineral oils, or
          phenoxyethanol.{' '}
          <Link rel="noopener noreferrer" target="_blank" to="/ingredients">
            Read our Ingredient Glossary
          </Link>{' '}
          for more information.
        </>
      ),
    },
    {
      question: 'Can Prose Custom Scalp Serum treat medical conditions like hair loss or dandruff?',
      answer:
        'Prose is not intended to treat medical conditions. Our formulas are a 100% drug-free alternative to prescription products and OTC (over-the-counter) medicines. Instead, we use only the highest quality, naturally powerful and proven-effective ingredients to enhance shine, volume, hair health, and so much more.',
    },
  ],
};

const hero = {
  isNew: true,
  title: 'Custom Scalp Serum',
  subtitle:
    'A lightweight, personalized serum for optimal scalp health and fuller, denser-looking hair.',
  description: '1.7 fl oz 50 mL',
  slider: [
    {
      src: { mobile: scalpSerum0, desktop: scalpSerum0Desktop },
      alt: 'Prose Custom Scalp Serum bottle set against a calming, neutral backdrop.',
      isNew: true,
    },
    {
      src: { mobile: scalpSerum1, desktop: scalpSerum1Desktop },
      alt: 'Close-up of a hand gripping a bottle of Prose Custom Scalp Serum, featuring a clear and attractive label design.',
    },
    {
      title: '89% agreed their scalp felt nourished*',
      subtitle:
        '*Based on self-assessment in a 4-week use-test of 97 subjects who used Prose Custom Scalp Serum daily.',
      src: { mobile: scalpSerum2, desktop: scalpSerum2 },
      alt: 'Close-up of a model using Prose Custom Scalp Serum on their scalp.',
    },
    {
      src: { mobile: scalpSerum3, desktop: scalpSerum3Desktop },
      alt: 'Close-up of a Prose Custom Scalp Serum bottle with ingredients and greenery.',
    },
    {
      src: { mobile: scalpSerum4, desktop: scalpSerum4Desktop },
      alt: 'Close-up of a Prose Custom Scalp Serum bottle with serum in use.',
    },
    {
      src: { mobile: scalpSerum5, desktop: scalpSerum5Desktop },
      alt: 'Models posing with Prose Custom Scalp Serum.',
    },
    {
      src: { mobile: scalpSerum6, desktop: scalpSerum6Desktop },
      alt: 'Comparison chart showing the benefits of Prose Custom Scalp Serum vs. other scalp serums.',
    },
  ],
  personalizationWorksBetter: {
    title: (
      <>
        personalization works better<sup>®</sup>
      </>
    ),
    description:
      'Prose Custom Scalp Serum is a fast-absorbing formula tailored to your unique needs — from restoring balance to itchy, oily, and dry scalps to soothing sensitivities. Used daily, it promotes a healthier scalp and stronger hair in 4 weeks.*',
    disclaimer: '*Results of a 4-week external use test performed on 97 subjects',
    reassurances: [
      'Dermatologist tested',
      'Boosts hair fullness + density over time',
      '99% natural ingredients',
      'Certified microbiome-friendly',
    ],
  },
  accordion: {
    custom: {
      list: [
        {
          title: 'Take our haircare consultation',
          description:
            'We’ll analyze 85+ factors — from what you eat to where you live — to understand the unique needs of your hair and scalp.',
        },
        {
          title: 'Your formulas are made to order',
          description:
            'Our AI-powered algorithm creates your personalized formulas + recommended routine, carefully selecting from 185+ clean ingredients to meet your hair goals.',
        },
        {
          title: 'As you change, so does your Prose',
          description:
            'We’ll address any new concerns, adjust your formulas with the seasons, and learn from your feedback for better hair with every order.',
        },
      ],
    },
    scientificResults: {
      title:
        'In a rigorous in-house study on Custom Scalp Serum, participants saw remarkable results over 30 days:',
      list: [
        // Alt attributes must remain empty in this case as the images are purely decorative
        { icon: healthSvgIcon, text: '81% agreed their scalp felt healthier*', alt: '' },
        {
          icon: comfortableSvgIcon,
          text: '87% agreed their scalp felt more comfortable*',
          alt: '',
        },
        {
          icon: nourishedSvgIcon,
          text: '89% agreed their scalp felt nourished*',
          alt: '',
        },
        { icon: itchySvgIcon, text: '83% agreed their scalp felt less itchy**', alt: '' },
        {
          icon: hydratedSvgIcon,
          text: '91% agreed their scalp felt more hydrated***',
          alt: '',
        },
      ],
      mentions: [
        '*Based on self-assessment in a 4-week use-test of 97 subjects who used Prose Custom Scalp Serum daily.',
        '**Based on self-assessment in a 4-week use-test of 72 subjects with self-declared scalp concerns of sensitivity, oiliness, or dryness who used Prose Custom Scalp Serum daily.',
        '***Based on self-assessment in a 4-week use-test of 24 subjects with self-declared scalp dryness concerns who used Prose Custom Scalp Serum daily.',
      ],
    },
    beforeAndAfter: {
      title:
        'Used daily, our Custom Scalp Serum can help boost hair density and balance sensitive scalps. Below are just a few examples of the targeted results you can expect.',
      slider: [
        {
          title: 'Before and after 90 days',
          description: 'Boosted hair density and fullness',
          imgSrc: densityBeforeAfterCarouselImg,
          alt: 'Before-and-after image showcasing improved hair density after using Prose Custom Scalp Serum.',
        },
        {
          title: 'Before and after 90 days',
          description: 'Thicker, fuller-looking hair',
          imgSrc: thicknessBeforeAfterCarouselImg,
          alt: 'Before-and-after image showcasing improved hair thickness after using Prose Custom Scalp Serum.',
        },
        {
          title: 'Before and after 90 days',
          description: 'Oil control and balanced scalp',
          imgSrc: oilinessBeforeAfterCarouselImg,
          alt: 'Before-and-after image showcasing improved oil control after using Prose Custom Scalp Serum.',
        },
        {
          title: 'Before and after 90 days',
          description: 'Reduced redness and flakiness',
          imgSrc: rednessBeforeAfterCarouselImg,
          alt: 'Before-and-after image showcasing reduced redness and flakiness after using Prose Custom Scalp Serum.',
        },
      ],
      mention:
        '†*Individual results after 3 months of using Prose Custom Scalp Serum daily. Results may vary.',
    },
    fragranceFree:
      'To support sensitive scalps, there’s no perfume, alcohol, or added fragrance in your Custom Scalp Serum, but it does contain — and may subtly smell like — natural plant extracts, including Rosemary.',
  },
  upsellModule: {
    image: {
      src: upsellModuleImage,
      alt: 'Prose Custom Hair Density Set bottles against a green background with leaves.',
    },
    title: 'The Custom hair density set',
    description: (
      <>
        Pair with <b>Custom Supplements</b> to promote hair health inside and out.
      </>
    ),
    link: {
      text: 'Discover the Set',
      to: '/pages/custom-hair-density-set',
    },
  },
};

const howToUse = {
  label: 'How to use',
  title: 'A scalp serum as unique as you are',
  description:
    'Each Custom Scalp Serum includes directions tailored to your unique hair, goals, and concerns — from thinning hair to an oily scalp. Below is a guide. ',
  amount: '2-3 full droppers',
  steps: [
    'Use daily on dry or damp hair.',
    'Part hair and apply serum directly to the scalp, focusing on areas of concern.',
    'Gently massage to distribute evenly.',
    'Do not rinse. Style hair as usual.',
  ],
  video: 'how-to-use-scalp-serum',
  posterImage: scalpSerumHowItWorksPicture,
};

const reviewsSlide1 = {
  name: 'Melody C.',
  date: '1/31/25',
  location: 'Oilville, VA',
  stars: '★★★★★',
  text: `The Prose Custom Scalp Serum is incredible! I noticed a huge reduction in the dryness and itchiness that I normally have on my scalp. I used two full droppers of the serum after my shower each night, applying it to my damp hair. Most other serums left my hair oily, no matter what I did. The Prose serum did not leave my hair oily at all!! It absorbed quickly into my scalp, and the dropper shape itself helped with precise application. I suffer with hair loss and breakage as well, and noticed that after using the serum, my hair felt stronger and there seemed to be less hair in my brush. I highly recommend this scalp serum by Prose!! It is, in all honesty, the best serum I have ever used!`,
};

const reviewsSlide2 = {
  name: 'Tiffany D.',
  date: '1/23/25',
  location: 'Philadelphia, PA',
  stars: '★★★★',
  text: `I started using Prose due to a painful and itchy scalp. With adding the Scalp Serum to my routine, I have noticed some relief from these symptoms. It has definitely helped reduce irritation, relieving some of my pain between washes. I would recommend it for sensitive scalps. `,
};

const reviewsSlide3 = {
  name: 'Mellissa S.',
  date: '1/29/25',
  location: 'Stillwater, MN',
  stars: '★★★★',
  text: `I tried the scalp serum and it was too heavy for my very fine, blonde hair. It’s recommended to use on damp hair at night if you find that it leads to oiliness. By trying it at night, on damp hair, I did notice less oiliness and my scalp felt less dry. `,
};

const reviewsSlide4 = {
  name: 'Kelly M.',
  date: '1/27/25',
  location: 'Pollock Pines, CA',
  stars: '★★★★',
  text: `I am typically not a hair serum or hair oil user as I have found many of them to be heavy and weigh down my waves. However, I agreed to try the Prose Scalp Serum as they knew my hair from using their other haircare products and I am so happy I did. Their Scalp Serum is light, nongreasy/oily, leaves no residue on my hair or scalp and, best of all, does not weigh down my waves. I've also noticed my hair is softer where I've applied the serum. `,
};

const reviewsSlide5 = {
  name: 'Madison R.',
  date: '1/26/25',
  location: 'Kyle, TX',
  stars: '★★★★',
  text: `A little bit of background: I have an oily scalp and dry hair lengths, and wash my hair every other day. I’ve been using this scalp serum daily by applying it to different parts of my scalp using 2-3 droppers full. I haven’t been using it long enough to see results for hair density/thickness but I do feel like the volume has improved and this doesn’t make my scalp oily at all! I was hesitant about a scalp serum making my oiliness worse but it is light and absorbs fairly quickly. Highly recommend applying this at night so that it is fully dry by morning. Don’t use it right before going out.`,
};

const reviewsSlide6 = {
  name: 'Orizema C.',
  date: '1/26/25',
  location: 'San Jose, CA',
  stars: '★★★★★',
  text: `I was super excited to hear Prose was coming out with a scalp serum because itchiness has been an on-and-off issue of mine for years now, one that mostly affects the areas around my middle part. So using the dropper, that’s where I applied the serum! I really did notice an instant soothing effect even during my first use and I’m pleased that it lasts for hours. I’ve been using the scalp serum for a few weeks now and find it to be most effective when applied as part of my morning routine rather than after an evening shower. I’d say that it has contributed to a more balanced scalp as well; my hair doesn’t feel as oily if I wait two days (rather than my usual one) in between washing!`,
};

const reviewsSlide7 = {
  name: 'Toni R.',
  date: '1/27/25',
  location: 'Thorton, CO',
  stars: '★★★★★',
  text: `I literally said, “Ahhh!” when I first put this serum on my itchy, sensitive scalp. I already use the scalp mask once per week to maintain my scalp’s health. This has been a great addition to my daily routine to combat the winter dryness! My scalp drank in the serum and immediately felt better. My hair is much fuller, easier to style, and is even shinier. I have lots of new hair growth where I had been shedding from the dryness. Love this product!`,
};

const reviewsSlide8 = {
  name: 'Megan D.',
  date: '1/26/25',
  location: 'Brooklyn, NY',
  stars: '★★★★★',
  text: `I absolutely LOVE this scalp serum!! It’s lightweight, easy to apply, and provides immediate relief for dry scalp. At first, I was concerned it would make my hair greasy and in need of more washing, but it’s been the complete opposite. It has hydrated my scalp enough (without creating oily roots!) that I don’t get itchy after a few days, so I’ve actually been able to extend wash day. If I use it in the morning on dry hair, the serum also gives my hair more life and volume after I rub it in, which is an unexpected bonus for my fine hair that often starts to look limp after day 2. I use the whole line of Prose products, and these great perks make it the new MVP in my book!`,
};

const reviewsSlide9 = {
  name: 'Colleen L.',
  date: '1/29/25',
  location: 'Salem, OR',
  stars: '★★★★★',
  text: `The scalp serum feels cool and refreshing. It's not oily or heavy. My formula is made with awesome ingredients like kombucha tea and maca root for strength and scalp health. It smells nice and and is a lovely addition to my Prose hair routine.`,
};

const productReviews = [
  reviewsSlide1,
  reviewsSlide2,
  reviewsSlide3,
  reviewsSlide4,
  reviewsSlide5,
  reviewsSlide6,
  reviewsSlide7,
  reviewsSlide8,
  reviewsSlide9,
];

export const scalpSerumPageContent = {
  faq,
  hero,
  howToUse,
  ticker,
  productReviews,
  productCarousel: { headline: 'Complete your haircare routine' },
  ingredientsSlider: {
    titleBlock: {
      title: 'Naturally powerful ingredients, picked just for you',
      subtitle:
        'Below are just a few possibilities. Your Custom Scalp Serum is made to order using a unique blend of only the clean, proven-effective ingredients your hair and scalp need.',
    },
    sliderCardsContent: [
      {
        ingredientName: 'Rosemary Extract',
        description: 'to support hair health and scalp vitality',
        img: {
          imgSrc: rosemary,
          imgAlt: 'Rosemary extract to support hair health and scalp vitality',
        },
      },
      {
        ingredientName: 'Hyaluronic Acid',
        description: 'to nourish and hydrate dry scalps',
        img: { imgSrc: acai, imgAlt: 'Hyaluronic acid for nourish and hydrate dry scalps' },
      },
      {
        ingredientName: 'Plant Collagen',
        description: 'to support the scalp’s moisture barrier',
        img: {
          imgSrc: acaciaCollagen,
          imgAlt: 'Plant collagen to support the scalp’s moisture barrier',
        },
      },
      {
        ingredientName: 'Maca Root',
        description: 'to promote hair density and strength',
        img: { imgSrc: macaRoot, imgAlt: 'Maca root to promote hair density and strength' },
      },
      {
        ingredientName: 'Rice Peptides',
        description: 'to help improve the appearance of thinning hair',
        img: {
          imgSrc: riceProtein,
          imgAlt: 'Rice peptides to help improve the appearance of thinning hair',
        },
      },
      {
        ingredientName: 'Kombucha Tea',
        description: 'to promote the scalp’s microbiome balance',
        img: {
          imgSrc: kombucha,
          imgAlt: 'Kombucha tea to promote the scalp’s microbiome balance',
        },
      },
      {
        ingredientName: 'Aniseed Myrtle Extract',
        description: 'to help calm and soothe scalp discomfort',
        img: {
          imgSrc: aniseed,
          imgAlt: 'Aniseed myrtle extract to help calm and soothe scalp discomfort',
        },
      },
      {
        ingredientName: 'Dog Rose Fruit Extract',
        description: 'to balance oily scalps and keep hair cleaner for longer',
        img: {
          imgSrc: dogRoseFruit,
          imgAlt: 'Dog rose fruit extract to balance oily scalps and keep hair cleaner for longer',
        },
      },
      {
        ingredientName: 'Jujube Bark Extract',
        description: 'to help control flaky scalps and calm irritation',
        img: {
          imgSrc: jujubeBarkExtract,
          imgAlt: 'Jujube bark extract to help control flaky scalps and calm irritation',
        },
      },
      {
        ingredientName: 'Peppermint Extract',
        description: 'to promote overall scalp health',
        img: {
          imgSrc: peppermintExtract,
          imgAlt: 'Peppermint extract to promote overall scalp health',
        },
      },
    ],
  },
};
